import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  makeStyles
} from "@material-ui/core";
import {
  useForm
} from "react-hook-form";
import { HookFormContent } from "components";
import {
  formSchema
} from "./schema";
import {
  AUTHORIZE_CREATE_POST
} from "config/url";
import { useCurl } from "zh-common-modules";

const useStyles = makeStyles(theme => ({
  addField : {
    padding : theme.spacing(0, 0, 1, 0)
  }
}));

export default function AddDialog(props){
  const {
    open,
    setOpen,
    refresh 
  } = props;
  const { curl } = useCurl(false, false);
  const classes = useStyles();
  const formContext = useForm({
    mode : "onBlur"
  });
  const { handleSubmit : sourceHandleSubmit } = formContext;

  const handleClose = () => {
    setOpen(false);
  }

  const handleSubmit = (data) => {
    curl.post(AUTHORIZE_CREATE_POST, data)
      .then(res => {
        handleClose()
        refresh();
      })
  }

  const breakpoints = { lg: 12, xl: 12, xs: 12, sm: 12, md: 12 };

  return (
    <Dialog
      open = {open}   
    >
      <DialogTitle>
        添加授权函
      </DialogTitle>
      <DialogContent
        dividers
      >
        <div>
          <Grid
            container
            // direction = "column"
          >
            {formSchema.map((schema, index) => {
              return (<Grid item key={index} {...breakpoints}>
                <div className={classes.addField}>
                  <HookFormContent schema={schema} formContext={formContext} />
                </div>
              </Grid>);
            })}
          </Grid>
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          variant = "contained"
          onClick = {handleClose}
          size = "small"
        >
          取消
        </Button>
        <Button
          variant = "contained"
          onClick = {sourceHandleSubmit(handleSubmit)}
          size = "small"
        >
          提交
        </Button>
      </DialogActions>
    </Dialog>
  )
}